import {
  useEVMContext,
  useQueryIpBlockStatus,
} from '@vertex-protocol/react-client';
import { WarningPanel } from 'client/components/WarningPanel';
import { BaseAppDialog } from 'client/modules/app/dialogs/BaseAppDialog';
import { useDialog } from 'client/modules/app/dialogs/hooks/useDialog';
import { clientEnv } from 'common/environment/clientEnv';
import { useEffect } from 'react';

export function ConnectWalletDialog() {
  const { hide } = useDialog();
  const { connectionStatus } = useEVMContext();
  const { data: ipBlockStatus } = useQueryIpBlockStatus();

  const isGeoblocked = !!ipBlockStatus;
  const isPrivyConfigured = clientEnv.integrations.isPrivyConfigured;

  const isConnected = connectionStatus.type === 'connected';

  useEffect(() => {
    if (isConnected) {
      hide();
    }
  }, [hide, isConnected]);

  if (!isGeoblocked && isPrivyConfigured) {
    return null;
  }

  return (
    <BaseAppDialog.Container onClose={hide}>
      <BaseAppDialog.Title onClose={hide}>
        Connect Wallet
      </BaseAppDialog.Title>
      <BaseAppDialog.Body>
        {isGeoblocked ? (
          <WarningPanel title="Restricted Territory">
            It appears that you are accessing from a Restricted Territory. At
            this time, we are not able to support users at your location.
          </WarningPanel>
        ) : (
          <WarningPanel title="Wallet Unavailable">
            Privy access is not configured for this environment.
          </WarningPanel>
        )}
      </BaseAppDialog.Body>
    </BaseAppDialog.Container>
  );
}
